var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$auth.isAdmin())?_c('h3',{staticClass:"text-h5 font-weight-bold mb-2 text--primary"},[_vm._v("Dashboard")]):_vm._e(),(_vm.$auth.isAdmin())?_c(_setup.DashboardResumido):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }